export default __webpack_public_path__ + "static/media/save.e9479e21.svg";